module.exports = __webpack_public_path__ + "img/ajax1.ff8aabf0.jpg";